import React, { useState } from 'react'
import toast from 'react-hot-toast';

function ContactUs() {

  const [formData, setFormData] = useState({
    name:'',
    email:'',
    phone:'',
    message:''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]:e.target.value})
  }

  const handleSubmit = async(e) => {
    e.preventDefault()
    setLoading(true)

    let response = await fetch('https://powerxone.onrender.com/api/contact/',{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formData)
    });

    const result = await response.json();

    if(response.ok) {
      toast.success('Thank you for contacting us!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: '',
      });
    } else {
      toast.error('Something went wrong.');
    }

    setLoading(false)
  }
  return (
    <section id="contact" className="contact section">
       
        <div className="container section-title mt-4">
          <div>
            <span>Contact</span> <span className="description-title">Us</span>
          </div>
        </div>
      

        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-info">
                <div className="contact-card">
                  <h3 className='mt-5'>Contact Information</h3>
                  <p className='mt-4'>
                    Feel free to reach out with any questions about the book,
                    speaking engagements, or media inquiries.
                  </p>

                  <div className="contact-details">
                    <div className="contact-item">
                      <i className="bi bi-envelope"></i>
                      <div>
                        <h4>Email:</h4>
                        <p>info@powerxone.com, sales@powerxone.com</p> 
                        {/* <p>sales@powerxone.com</p> */}
                      </div>
                    </div>

                    <div className="contact-item">
                      <i className="bi bi-telephone"></i>
                      <div>
                        <h4>Phone:</h4>
                        <p>+8801742-904023</p>
                      </div>
                    </div>

                    <div className="contact-item">
                      <i className="bi bi-geo-alt"></i>
                      <div>
                        <h4>Address:</h4>
                        <p>Nikunja 2, Khilkhet</p>
                        <p>Dhaka-1229</p>
                      </div>
                    </div>
                  </div>

                  <div className="social-links">
                    <a href="#"><i className="bi bi-whatsapp"></i></a>
                    <a href="#"><i className="bi bi-facebook"></i></a>
                    <a href="#"><i className="bi bi-instagram"></i></a>
                    <a href="#"><i className="bi bi-linkedin"></i></a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="contact-form-wrapper">
                <form
                  onSubmit={handleSubmit}
                  className="php-email-form"
                >
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label for="name">Your Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="form-control"
                        id="name"
                        placeholder="John Doe"
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group mt-3 mt-md-0">
                      <label for="email">Your Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        id="email"
                        placeholder="john@example.com"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group mt-3">
                    <label for="subject">Phone</label>
                    <input
                      type="number"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      id="subject"
                      placeholder="01XXXX XXXXX"
                      required
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label for="message">Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="2"
                      placeholder="Your message here..."
                      required
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" disabled={loading}>
                      {loading ? 'Sending....' : 'Send Message'}
                      </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* <div className='container mt-5' style={{ width: '100%', height: '450px' }}>
            <iframe
                title="Google Map Location"
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3649.6840836259535!2d90.4136566737356!3d23.8298304286163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNikunja-2%2C%20Khilkhet%2C%20Dhaka-1229%20(Opposite%20Site%20Of%20Nagorik%20Television)%20%20(Unique%20Studio%20Building)!5e0!3m2!1sen!2sbd!4v1751950782070!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div> */}
      </section>
  )
}

export default ContactUs